var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"options-bg"},_vm._l((_vm.titles),function(item,index){return _c('div',{key:index,staticClass:"navBtn"},[_c('CButton',{attrs:{"selected":index == _vm.currentIndex,"title":item.title},on:{"click":function($event){return _vm.onClickBtn(item, index)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }